<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">Profit/(Loss) per Program     
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="step1()"><i class="fa fa-cloud-upload"></i> Import Pola Acar</b-button>
          <b-button variant="primary mr-1" @click="edit" :disabled="!(frmUpload.periode)">Add/Edit</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend>
                <span class="pt-1 mr-2">Periode Pnl per Program </span>
              </b-input-group-prepend>
              <vue-monthly-picker
                style="width:350px;"
                v-model="frmUpload.periode"
                dateFormat="MMMM YYYY"
                :monthLabels="monthLabels" :state="!$v.frmUpload.periode.$error"
              ></vue-monthly-picker>
            <b-input-group-append>
              <b-button variant="success" class="ml-1" @click="refresh()">
                <i class="fa fa-play"></i> Open
              </b-button>
            </b-input-group-append>
          </b-input-group>            
        </b-col>
      </b-row>
      <b-row v-if="(filterShow=='Hide')">
          <b-col lg="6">
              <b-form-group
                  label="Filter"
                  label-cols-sm="1"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                  >
                  <b-input-group size="sm">
                      <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
                  </b-form-group>            
          </b-col>         
          <b-col lg="6">
                  <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch switch>
                    <b> {{ filterShow }}</b> Filter
                  </b-form-checkbox>
          </b-col>         
      </b-row>

      <b-table
          class="mb-0"
          ref="tableOri"
          sticky-header="600px" outlined responsive striped hover
          style="font-size:smaller;"
          :items="pnlData"
          :fields="tblOri.fields"
          :current-page="tblOri.page"
          :per-page="tblOri.limit"
          :sort-by.sync="tblOri.sortBy"
          :sort-desc.sync="tblOri.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"   @row-clicked="rowClicked"             
      >
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblOri.page - 1) * tblOri.limit + 1}}
            to <span v-if="((tblOri.page * tblOri.limit)>tblOri.total)">{{tblOri.total}}</span> <span v-else>{{tblOri.page * tblOri.limit}}</span>
            of {{tblOri.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
            <select  v-model="tblOri.limit"  style="width:60px;">
              <option>10</option>
              <option>15</option>
              <option>20</option>                            
              <option>25</option>
              <option>30</option>                            
            </select>
          </div>
        </b-col>                      
        <b-col cols="3">            
          <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch switch>
            <b> {{ filterShow }}</b> Filter
          </b-form-checkbox>

        </b-col>
        <b-col cols="5">            
          <b-pagination 
            align="right"
            :total-rows="tblOri.total"
            :per-page="tblOri.limit"
            v-model="tblOri.page"
          ></b-pagination>
        </b-col>
      </b-row>      
    </b-card>

    <b-card>
      <div slot="header">Summary QTY * DURATION   
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="edit" >Edit</b-button>
        </div>
      </div>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>

    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">TV Program - Add/Edit Form 
          </div>
                    <b-input-group >
                        <b-input-group-prepend><label>Program Name</label></b-input-group-prepend>
                        <b-form-input v-model="model.nama" :state="!$v.model.nama.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Program Code</label></b-input-group-prepend>
                        <b-form-input v-model="model.kode" :state="!$v.model.kode.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Program Group</label></b-input-group-prepend>
                        <b-form-select style=" width: 50%;"  v-model="model.groupprog" :plain="true" :options="groups" :state="!$v.model.groupprog.$error"></b-form-select>
                        <b-input-group-prepend><span  class="pt-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;Rate Spot</span></b-input-group-prepend>
                        <b-form-select  v-model="model.spotrate" :plain="true" :options="spotrates" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Product Type</label></b-input-group-prepend>
                        <b-form-select style=" width: 50%;"  v-model="model.progtype" :plain="true" :options="progtypes" ></b-form-select>
                        <b-input-group-prepend><span  class="pt-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;Rate Spot</span></b-input-group-prepend>
                        <b-form-select  v-model="model.spotrate" :plain="true" :options="spotrates" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>News Category/Dep</label></b-input-group-prepend>
                        <b-form-select  v-model="model.newscateg" :plain="true" :options="newscategs" ></b-form-select>
                        <b-form-select class="ml-1" v-model="model.newsdep" :plain="true" :options="newsdeps" ></b-form-select>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>LIVE Production</label></b-input-group-prepend>
                      <b-form-select  v-model="model.studiolive" :plain="true" :options="studiolives" ></b-form-select>
                        <b-input-group-append>
                                <span class="input-group-text">Studio/Equipment Std. Cost</span>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>TAPING Production</label></b-input-group-prepend>
                        <b-form-select  v-model="model.studiotape" :plain="true" :options="studiotapes" ></b-form-select>
                        <b-input-group-append>
                                <span class="input-group-text">Studio/Equipment Std. Cost</span>
                        </b-input-group-append>
                    </b-input-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
        </b-col>
      </b-row>

  </div>
</template>

<style lang="scss">
    .ColsDefine {
      .input-group {
          .input-group-prepend {
              label {
                  width: 135px !important;
              }
          }
      }
    }

</style>


<script>
import VueMonthlyPicker from "vue-monthly-picker";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import crud from "../../apis/crud";
import programtv from "../../apis/programtvpnl";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {VueMonthlyPicker, Loading},
  mixins: [validationMixin],
  validations: {
        frmUpload: {
            periode: { required }
        },
    model: {
        nama: { required },
        kode: { required },
        groupprog: { required },
    },

  }, 
  data() {
    return {
      showDelConfirm: false,
      isLoading:false,
      showForm: false,
      frmUpload:{periode:''},
      tblOri: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "kode",
            label: "Program Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "nama",
            label: "Program Name",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "groupname",
            label: "Program Group",
            sortable: true
          },
          {
            key: "news",
            label: "News Category/Dep",
            sortable: true
          },
          {
            key: "live",
            label: "Live/Taping",
            sortable: true
          },
          {
            key: "blocking",
            label: "Blocking",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "spotrate",
            label: "Rate Spot",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "quantity",
            label: "Qty",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "durasi",
            label: "DUR",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "hari",
            label: "Hari",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "jam",
            label: "Jam",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ]
      },      
      model:{},
      blockings:[{ value:'', text:'--ALL--'},{ value:'1', text:'BLOCKING'},{ value:'0', text:'NON BLOCKING'}],
      lives:[{ value:'', text:'--ALL--'},{ value:'1', text:'LIVE'},{ value:'0', text:'TAPING'}],
      newscategs:['--ALL--','SOFTNEWS','HARDNEWS'],
      newsdeps:['--ALL--','MAGAZINE','NEWS GATHERING'], 
      filtergroups:[{value:'', text:'--ALL--'}],
      monthLabels: dropdown.monthLabels,
      pnlData:[],
      filter: null,
      filterOn: ['groupprog','prognama','newscateg', 'newsdep', 'blocking'],   
      filterShow:'Show',   
    };
  },
  computed: {
    // dimension(){
    //   return this.$store.state.dimension;
    // },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
  },
  // watch:{
  //   dimCol: function(newval) {
  //       this.tblData.DimVal="";
  //       this.tblData.DimValInfo="";
  //       this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
  //   },
  // },
  created: async function(){
        const [a,b,c] = await Promise.all([
          crud.list({
            tablename:'programtv-group',
            sortBy: 'seqno',
            sortDesc: false
          }),
          crud.list({
            tablename:'vwstudiorate',
            sortBy: 'studioname',
            sortDesc: false
          }),
          crud.list({
            tablename:'programrate',
            sortBy: 'seqno',
            sortDesc: false
          })                    
          ]);
        this.groups = a.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[]);
        this.filtergroups=this.filtergroups.concat(this.groups);
        this.studiolives = b.reduce((newArr,item) =>{
            if (item.liveprod==1){
              newArr.push({ value: item.studiocode, text: item.studioname});
            }
            return newArr;
        },[{value:'',text:'--ALL--'}]);
        this.spotrates = c.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[{value:'',text:'--ALL--'}]);

    
      const tglaktif = moment(new Date(), 'YYYY-MM-DD');
      this.tblData.tgl1 =  tglaktif.startOf('month').format('YYYY-MM-DD');
      this.tblData.tgl2 =  tglaktif.endOf('month').format('YYYY-MM-DD');

  },  
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblOri.total = filteredItems.length;
      this.tblOri.page = 1;
    },  
    getData: async function(ctx) {
      // const filter = this.$store.state.filter;
      //   let filtered=false;
      //   for (var key in filter.polist) {
      //       this.tblData[key] = filter.polist[key];
      //       filtered=true;
      //   }
      //   if (filtered === true) {
      //     this.showFilter=filtered;
      //     delete filter.polist;
      //     this.$store.commit("filter", filter);
      //   }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await programtv.list(this.tblData);      
      this.isLoading=false;
      this.pnlData= list;
      // return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    step1: function() {
          router.push({name :'budget.pnlprogprocess1'});
    },
    add: function(data) {
        for (var key in this.model) {
            this.model[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.model) {
            this.model[key] = '';
        }
        for (var key in this.model) {
            this.model[key] = this.model[key];
        }
      this.model.idlama = data.kode;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.model.idlama) {
                await crud.update(
                     {tablename:'programtv', 
                     key:this.model.idlama, 
                     data:{nama:this.model.nama, kode:this.model.kode,groupprog:this.model.groupprog, spotrate:this.model.spotrate, progtype:this.model.progtype,
                     newscateg:this.model.newscateg,newsdep:this.model.newsdep, studiolive:this.model.studiolive, studiotape:this.model.studiotape}
                      });
              } else {
                await crud.insert(
                  { tablename:'programtv',                      
                     data:{nama:this.model.nama, kode:this.model.kode,groupprog:this.model.groupprog, spotrate:this.model.spotrate, progtype:this.model.progtype,
                     newscateg:this.model.newscateg,newsdep:this.model.newsdep, studiolive:this.model.studiolive, studiotape:this.model.studiotape}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'programtv', key:this.model.kode});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await programtv.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push('home');
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.tendering')) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
      //   // router.push({name:'payable.apinv'});
      //     router.push("home");
      // }
    }

  }
};
</script>
